module.exports = __webpack_public_path__ + "img/SAFo_StrongPasswords_Passphrases-Tilt.91d2e010.svg";